<template>
  <div class="exchange">
    <Header title="兑换" :haveHeight="true" url="transparent"></Header>

    <div class="exchange_main">
      <div class="exchange_hint">
        实体权益为实物，需要邮寄，请您填写正确的收货地址
      </div>

      <div class="exchange_address">
        <img
          mode="widthFix"
          src="../../assets/images/preview/select_address.png"
        />

        <div class="exchange_text" @click="select">
          {{ !address.id ? "选取地址" : "更换地址" }}
        </div>
      </div>

      <div class="address" v-if="address.id">
        <!-- 收件人 -->
        <div class="name">{{ address.name }}</div>
        <!-- 手机号 -->
        <div class="phone">{{ address.phone }}</div>
        <!-- 省市区详情地址 -->
        <div class="address_text">
          {{ address.province }}{{ address.city }}{{ address.area
          }}{{ address.detail_address }}
        </div>
      </div>
      <div class="open" @click="open">提交</div>
    </div>

    <!-- 用户二次确认 -->
    <div class="mask" v-if="status">
      <div class="address_mask">
        <div class="colse">
          <img
            mode="widthFix"
            src="https://oss01.dayou.art/dayouwx/colse.png"
            @click="colse"
          />
        </div>

        <div class="address_block">
          <!-- 收件人 -->
          <div class="name">{{ address.name }}</div>
          <!-- 手机号 -->
          <div class="phone">{{ address.phone }}</div>
          <!-- 省市区详情地址 -->
          <div class="address_text">
            {{ address.province }}{{ address.city }}{{ address.area
            }}{{ address.detail_address }}
          </div>
        </div>

        <div class="hint">
          <img mode="widthFix" src="https://oss01.dayou.art/dayouwx/hint.png" />
          <div>地址确认后不可修改</div>
        </div>

        <div class="submit" @click="submit">确认</div>
      </div>
    </div>
  </div>
</template>

<script>
import { config_data, exchange } from "@/api/quanyi.js";
export default {
  data() {
    return {
      address: {
        phone: "",
        name: "",
        address: "",
        id: 0,
      },
      backpack_id: 0,
      rights_ref_id:0,
      status: false,
      isCheck: true,
      nft_id: 0,
      name: "",
      quanyi_name: "",
    };
  },

  created() {
    const query = this.$route.query;
	if(this.$route.query.token){
		localStorage.setItem('token',this.$route.query.token)
	}
    this.backpack_id = query.backpack_id;
    this.nft_id = query.nft_id;
    this.name = query.name;
    this.quanyi_name = query.quanyi_name;
    this.rights_ref_id=query.rights_ref_id
    this.get_config_data();
    const currentAddress = localStorage.getItem("currentAddress");
    if (currentAddress) {
      this.address = JSON.parse(currentAddress);
      localStorage.removeItem("currentAddress");
    }
  },

  methods: {
    //跳转选择地址
    select() {
      this.$router.push({
        name: "addressBook",
        query: {
          type: 1,
          id: this.address.id,
          step: 2,
        },
      });
    },
    //打开
    open() {
      const { address } = this;
      if (address.id) {
        this.status = true;
      }
    },

    // 获取自定义配置值
    get_config_data() {
      const query = {
        tags: ["yushouTutorial"],
      };
      config_data(query).then((data) => {
        this.img = data.yushouTutorial;
      });
    },

    //退出
    colse() {
      this.status = false;
    },
    //提交表单
    submit() {
      const {
        backpack_id,
        address: { id },
      } = this;
      exchange({
        backpack_id,
        address_id: id,
        rights_ref_id:this.rights_ref_id
      }).then(() => {
		  this.$router.push({name:"exchangeSuccess"})
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "./exchange.less";
</style>
